const backBtn = () => {
  const btns = document.querySelectorAll('[back-btn]')

  if(!btns.length > 0) return

  btns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault()

      window.history.back()
      // window.location = "/"
    })
  })
}
export default backBtn
